export { KitTabGroup, KitTab } from './KitTabGroup';
